import React from 'react'
import PropTypes from 'prop-types'
import { cn } from '../../lib/utils'
import './AuthenticatedAppShell.scss'

const AuthenticatedAppShell = ({
  children,
  hideNavigationOnMobile = false,
  navigation,
}) => (
  <div
    className={cn(
      'authenticated-app-shell',
      hideNavigationOnMobile && 'authenticated-app-shell--mobile-navigation-hidden',
    )}
  >
    <div className="app-navigation-slot">
      {navigation}
    </div>
    <main className="content-container">
      <div className="content-card">
        {children}
      </div>
    </main>
  </div>
)

AuthenticatedAppShell.propTypes = {
  children: PropTypes.node.isRequired,
  hideNavigationOnMobile: PropTypes.bool,
  navigation: PropTypes.node.isRequired,
}

export default AuthenticatedAppShell
